module.exports = __webpack_public_path__ + "img/title5.d20e00f7.png";